import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RoleService } from './role.service';

@Directive({
  selector: '[hasRole]'
})
export class HasRoleDirective {

  private hasView = false;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef,
    private roleService: RoleService) { }

  @Input() set hasRole(role: string) {
    this.roleService.hasRole(role)
    .then(hasRole => {
      if (hasRole && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if(!hasRole && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
